import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { QuizRouter } from '../../../quiz/types';
import { modules } from '../../modules';

@injectable()
export class QuizRouterService implements QuizRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToDetail(id: string) {
    this.history.push(`/${this.role.get()}/${modules.quiz.basename}/${id}`);
  }

  goToEdit(query: string) {
    if (!query || query === '?') {
      this.history.push(`/${this.role.get()}/${modules.quiz.basename}/edit`);
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.quiz.basename}/edit`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${this.role.get()}/${modules.quiz.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.quiz.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToCreate(accountId: string) {
    this.history.push({
      pathname: `/${this.role.get()}/${modules.quiz.basename}/create`,
      search: `?account_id=${accountId}`,
    });
  }

  goBack(prevState: { pathname: string; search: string }) {
    this.history.push(prevState);
  }

  goToAnalytics(id: string, query?: string) {
    if (!query || query === '?') {
      this.history.push(
        `/${this.role.get()}/${modules.quiz.basename}/${id}/analytics`,
      );
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.quiz.basename}/${id}/analytics`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToSurveyUserAnswers(surveyId: string, attemptId: string) {
    this.history.push(
      `/${this.role.get()}/${modules.quiz.basename}/${surveyId}/analytics/${attemptId}`,
    );
  }
}
